export default __webpack_public_path__ + "static/media/profiles.543010cb.svg";